export default __webpack_public_path__ + "static/media/wi_11n_thunderstorm.21a7217f.svg";